import LoyaltyTierIcon from 'LuxKit/Icons/loyalty/LoyaltyTierIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import type { ComponentProps } from 'react'
import _PriceRowLoyaltyPointsContent from './_PriceRowLoyaltyPointsContent'

interface Props extends Omit<ComponentProps<typeof _PriceRowLoyaltyPointsContent>, 'horizontalAlign'> {
  tier: App.LoyaltyTier
  size: 'S' | 'M'
  /**
   * @default start
   */
  horizontalAlign?: 'start' | 'center'
  /** Hide the decorative tier emblem when the surrounding layout already supplies the context. */
  hideTierIcon?: boolean
}

const SIZES_BODY_TEXT_VARIANTS: Record<Props['size'], ComponentProps<typeof BodyTextBlock>['variant']> = {
  S: 'small',
  M: 'medium',
}

const TIER_BODY_TEXT_COLOURS: Record<App.LoyaltyTier, App.Design.ContentColour> = {
  bronze: 'tier-bronze-dark',
  silver: 'tier-silver-dark',
  gold: 'tier-gold-dark',
  platinum: 'tier-platinum-dark',
  infinite: 'tier-infinite-dark',
}

function PriceRowLoyaltyPoints({
  tier,
  size,
  earnablePoints,
  statusCredits,
  calculationType,
  pointsEarnRatio,
  horizontalAlign = 'start',
  onInfoIconClick,
  hideTierIcon = false,
}: Props) {
  return <BodyTextBlock
    variant={SIZES_BODY_TEXT_VARIANTS[size]}
    colour={TIER_BODY_TEXT_COLOURS[tier]}
    weight="bold"
    align={horizontalAlign}
    startIcon={hideTierIcon ? undefined : <LoyaltyTierIcon size="S" tier={tier} />}
  >
    <_PriceRowLoyaltyPointsContent
      earnablePoints={earnablePoints}
      statusCredits={statusCredits}
      pointsEarnRatio={pointsEarnRatio}
      onInfoIconClick={onInfoIconClick}
      calculationType={calculationType}
      horizontalAlign={horizontalAlign}
    />
  </BodyTextBlock>
}

export default PriceRowLoyaltyPoints
